import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import {
  LoginModel,
  MainDepartment,
  TopPerformer
} from '../../../Models/ApplicationModels';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { WeekColorService } from '../../admin-module/company-config/WeekColors/services/week-color.service';

@Component({
  selector: 'app-top-performer',
  templateUrl: './top-performer.component.html',
  styleUrls: ['./top-performer.component.css']
})
export class TopPerformerComponent {
  sortVals: boolean = true;
  isTableData: boolean = true;
  showWeeklyOption: boolean = true;
  deptID: number = 0;
  mainDepartmentList: Array<MainDepartment> = [];
  weekData: any = [];
  startDate: any;
  endDate: any;
  dayStartDate: any;
  dayEndDate: any;
  isLoading: boolean = false;
  previousStartDate: string | undefined;
  previousEndDate: string | undefined;
  isItemEntry: boolean = false;
  topPerformerTabId: number = 0;
  performance: any;
  performerData: TopPerformer[] = [];
  performerData2: any = [];
  performanceCardDaily: any = [];
  performanceCardWeekly: any = [];
  performanceCardMonthly: any = [];
  performanceEmpDaily: any = [];
  performanceEmpWeekly: any = [];
  performanceEmpMonthly: any = [];
  cycleId: number = 0;
  periodId: number = 1;
  isEmpCard: boolean = false;
  deptDataFetchCount: number = 0;
  imgArray = [
    'assets/dashboard/img_storeTopPerformer1.svg',
    'assets/dashboard/img_storeTopPerformer2.svg',
    'assets/dashboard/img_storeTopPerformer3.svg'
  ];
  icArray = [
    'assets/dashboard/ic_topPerformer1.svg',
    'assets/dashboard/ic_topPerformer2.svg',
    'assets/dashboard/ic_topPerformer3.svg'
  ];
  empImgArray = [
    'assets/dashboard/img_topPerformer1.svg',
    'assets/dashboard/img_topPerformer2.svg',
    'assets/dashboard/img_topPerformer3.svg'
  ];
  empCardPerformer: boolean = false;
  storeCardPerformer: boolean = false;
  userInfo: LoginModel = new LoginModel();
  periodArray: {
    value: number;
    name: string;
    startDate: string;
    endDate: string;
  }[] = [];
  periodDayArray: {
    value: number;
    name: string;
    startDate: string;
    endDate: string;
  }[] = [];
  reportHasRun: boolean = false;
  private isDataInitialized = false;
  private lastUpdateTime: number = 0;
  private readonly UPDATE_THRESHOLD = 1000;
  loading: boolean = false;
  constructor(
    private breadcrumbService: BreadcrumbService,
    private masterservice: MasterDataSeriveService,
    private datepipe: DatePipe,
    private weekColorService: WeekColorService
  ) {}

  async ngOnInit() {
    this.breadcrumbService.updateActiveDeptTab('Home');
    this.breadcrumbService.updateActiveCategoryTab('Top Performer');
    this.startDate = moment().subtract(1, 'days');
    this.endDate = moment();
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeeklyOption = productionScheduleType !== 'datespecific';
    if (!this.showWeeklyOption && this.periodId === 2) {
      this.periodId = 1;
    }
    await this.initializeData();
  }

  private async initializeData(): Promise<void> {
    if (this.isDataInitialized) {
      return;
    }

    try {
      await this.getMainDepartments();
      await this.selectPeriod();
      this.isDataInitialized = true;
    } catch (error) {
      console.error('Error initializing data:', error);
    }
  }

  topPerformerTabChange() {
    // Switching tabs must not auto-fetch. Only the tab/UI state is updated here;
    // the user must click Run Report to (re)load data for the selected view.
    if (!this.isTableData) {
      this.empCardPerformer = false;
      this.isEmpCard = true;
    }
  }

  toggleTableOrGraph(flag: boolean) {
    // Switching between table and graph must not auto-fetch. The user must click
    // Run Report to load data for the newly selected view. State is preserved.
    if (flag) {
      this.isTableData = true;
      this.periodId = 1;
      this.getDays();
    } else {
      this.isTableData = false;
    }
    this.topPerformerTabChange();
  }

  /* Builds the period selectors and loads the card-view (graph) data. */
  private async loadCardData(): Promise<void> {
    this.loading = true;
    this.getDays();
    if (this.showWeeklyOption) {
      this.getProductionCycle();
      this.getWeeks();
    }
    this.getMonths();
    this.initialCardDailyData();
    if (this.showWeeklyOption) {
      this.initialCardWeeklyData();
    }
    this.initialCardMonthlyData();
  }

  async runReport() {
    this.reportHasRun = true;
    if (!this.isTableData) {
      await this.loadCardData();
    }
    this.topPerformerTabChange();
    if (this.isTableData) {
      this.getEmployeePerformer();
    }
  }

  getMainDepartments() {
    return new Promise<void>((resolve) => {
      this.masterservice.getDepartmentsProduction(false, 0).subscribe({
        next: (Response: any) => {
          this.mainDepartmentList = Response as MainDepartment[];
          resolve();
        },
        error: (err) => {
          console.error('Error fetching departments:', err);
          resolve();
        }
      });
    });
  }

  async selectPeriod() {
    const selectedValue = this.periodId;
    if (selectedValue === 1) {
      this.getDays();
    }
    if (selectedValue === 2) {
      if (!this.showWeeklyOption) {
        this.periodId = 1;
        this.getDays();
        return;
      }
      this.getWeeks();
      this.getProductionCycle();
    }
    if (selectedValue === 3) {
      this.getMonths();
    }
  }

  getDays() {
    this.periodDayArray = [];
    for (let i = 0; i <= 6; i++) {
      const startDate = moment().subtract(i, 'days').format('YYYY-MM-DD');
      const endDate = moment().subtract(i, 'days').format('YYYY-MM-DD');
      const name = moment().subtract(i, 'days').format('YYYY-MM-DD');
      if (i === 0 && this.isTableData) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.previousStartDate = moment(startDate)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
        this.previousEndDate = moment(endDate)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
        this.cycleId = 0;
        // Filter changes must not auto-fetch; the user must click Run Report.
      }
      this.periodDayArray.push({
        value: i,
        name: name,
        startDate: startDate,
        endDate: endDate
      });
    }
  }

  getWeeks() {
    const currentDate = moment(); // today
    this.periodArray = [];

    for (let i = 0; i < 6; i++) {
      const weekDate = currentDate.clone().subtract(i, 'weeks');

      const startDate = weekDate.startOf('week').format('YYYY-MM-DD'); // Sunday
      const endDate = weekDate.endOf('week').format('YYYY-MM-DD'); // Saturday

      const weekName = `Week ${i + 1} (${moment(startDate).format('DD MMM')} - ${moment(endDate).format('DD MMM')})`;

      if (i === 0 && this.isTableData) {
        this.startDate = startDate;
        this.endDate = endDate;

        this.previousStartDate = moment(startDate)
          .subtract(1, 'weeks')
          .startOf('week')
          .format('YYYY-MM-DD');

        this.previousEndDate = moment(endDate)
          .subtract(1, 'weeks')
          .endOf('week')
          .format('YYYY-MM-DD');
        // Filter changes must not auto-fetch; the user must click Run Report.
      }

      this.periodArray.push({
        value: i,
        name: weekName,
        startDate: startDate,
        endDate: endDate
      });
    }
  }

  getMonths() {
    const currentDate = moment(); // Current date
    this.periodArray = [];
    for (let i = 0; i < 12; i++) {
      const subtractedDate = currentDate.clone().subtract(i, 'months');
      const startDate = subtractedDate.startOf('month').format('YYYY-MM-DD');
      const endDate = subtractedDate.endOf('month').format('YYYY-MM-DD');
      const monthName = subtractedDate.format('MMMM');
      if (i === 0 && this.isTableData) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.previousStartDate = moment(startDate)
          .subtract(1, 'months')
          .format('YYYY-MM-DD');
        this.previousEndDate = moment(endDate)
          .subtract(1, 'months')
          .format('YYYY-MM-DD');
        this.cycleId = 0;
        // Filter changes must not auto-fetch; the user must click Run Report.
      }
      this.periodArray.push({
        value: i,
        name: monthName,
        startDate: startDate,
        endDate: endDate
      });
    }
  }
  sortValues(val: string) {
    this.sortVals = !this.sortVals; // toggle asc/desc

    switch (val) {
      case 'TotalItems':
        this.performerData.sort((a, b) =>
          this.sortVals
            ? a.totalItems - b.totalItems
            : b.totalItems - a.totalItems
        );
        break;

      case 'TotalPrice':
        this.performerData.sort((a, b) =>
          this.sortVals
            ? a.totalPrice - b.totalPrice
            : b.totalPrice - a.totalPrice
        );
        break;

      case 'UserName':
        this.performerData.sort((a, b) =>
          this.sortVals
            ? a.userName.localeCompare(b.userName)
            : b.userName.localeCompare(a.userName)
        );
        break;

      case 'position':
        this.performerData.sort((a, b) =>
          this.sortVals ? a.position - b.position : b.position - a.position
        );
        break;
    }
  }

  getProductionCycle(): Promise<void> {
    return new Promise((resolve, reject) => {
      let user = this.masterservice.getUserDetailsFromStorage();
      this.weekColorService
        .getProductionCycleSchedule(user.companyID)
        .subscribe({
          next: (res: any) => {
            const colors = res as any[];

            this.weekData = [];
            colors.forEach((r) => {
              this.weekData.push({
                id: r.productionCycleId,
                colorName: r.displayName,
                color: r.color
              });
            });

            this.cycleId = this.weekData[0]?.id ?? 0;
            resolve();
          },
          error: (err) => reject(err)
        });
    });
  }

  initialCardDailyData() {
    const today = moment().format('YYYY-MM-DD');
    const previousDay = moment().subtract(1, 'days').format('YYYY-MM-DD');
    this.startDate = today;
    this.endDate = this.startDate;
    this.previousStartDate = previousDay;
    this.previousEndDate = this.previousStartDate;

    this.getEmployeeCardPerformer(1);
    // this.getStoreCardDailyPerformer(1);
  }

  initialCardWeeklyData() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.weekColorService
      .getProductionCycleSchedule(user.companyID)
      .subscribe((res: any) => {
        this.cycleId = res[0].productionCycleId;

        // Current week (Sunday - Saturday)
        const currentWeekStart = moment().startOf('week'); // Sunday
        const currentWeekEnd = moment().endOf('week'); // Saturday

        // Previous week (Sunday - Saturday)
        const previousWeekStart = moment().subtract(1, 'week').startOf('week');
        const previousWeekEnd = moment().subtract(1, 'week').endOf('week');

        this.startDate = currentWeekStart.format('YYYY-MM-DD');
        this.endDate = currentWeekEnd.format('YYYY-MM-DD');

        this.previousStartDate = previousWeekStart.format('YYYY-MM-DD');
        this.previousEndDate = previousWeekEnd.format('YYYY-MM-DD');

        this.getEmployeeCardPerformer(2);

        this.loading = false;
      });
  }

  initialCardMonthlyData() {
    const today = moment();
    const currentMonthStart = today
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD');
    const currentMonthEnd = today.clone().endOf('month').format('YYYY-MM-DD');
    const previousMonthStart = today
      .clone()
      .subtract(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD');
    const previousMonthEnd = today
      .clone()
      .subtract(1, 'month')
      .endOf('month')
      .format('YYYY-MM-DD');
    this.startDate = currentMonthStart;
    this.endDate = currentMonthEnd;
    this.previousStartDate = previousMonthStart;
    this.previousEndDate = previousMonthEnd;
    this.cycleId = 0;
    this.getEmployeeCardPerformer(3);
    // this.getStoreCardDailyPerformer(3);
  }

  formateDate(event: any) {
    const selectedIndex = event.target.value;
    // Daily (periodId 1) options are rendered from periodDayArray; Weekly (2)
    // and Monthly (3) options are both rendered from periodArray. The Monthly
    // case previously fell through to a weekData lookup, which threw
    // "Cannot read properties of undefined (reading 'id')" because weekData is
    // empty in Monthly mode and left the dates unchanged.
    if (this.periodId === 1) {
      if (selectedIndex >= 0 && selectedIndex < this.periodDayArray.length) {
        const selectedPeriod = this.periodDayArray[selectedIndex];
        const selectPrevPeriod = this.periodDayArray[selectedIndex - 1];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        if (selectPrevPeriod) {
          this.previousStartDate = selectPrevPeriod!.startDate;
          this.previousEndDate = selectPrevPeriod!.endDate;
        }
      }
    } else {
      if (selectedIndex >= 0 && selectedIndex < this.periodArray.length) {
        const selectedPeriod = this.periodArray[selectedIndex];
        const selectPrevPeriod = this.periodArray[selectedIndex - 1];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        if (selectPrevPeriod) {
          this.previousStartDate = selectPrevPeriod!.startDate;
          this.previousEndDate = selectPrevPeriod!.endDate;
        }
      }
    }
    // Filter changes must not auto-fetch; the user must click Run Report.
  }

  formateCardDetailDates(event: any, flag: number) {
    let selectedIndex = event.target.value;
    if (flag == 1) {
      if (selectedIndex >= 0 && selectedIndex < this.periodDayArray.length) {
        const selectedPeriod = this.periodDayArray[selectedIndex];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        this.dayStartDate = this.startDate;
        this.dayEndDate = this.endDate;
      }
      if (this.isEmpCard) {
        this.getEmployeeCardPerformer(1);
      } else {
        this.getStoreCardDailyPerformer(1);
      }
    } else {
      if (flag == 3) {
        if (selectedIndex >= 0 && selectedIndex < this.periodArray.length) {
          // Retrieve the object from periodArray using the index
          const selectedPeriod = this.periodArray[selectedIndex];
          this.startDate = selectedPeriod!.startDate;
          this.endDate = selectedPeriod?.endDate;
        }
        if (this.isEmpCard) {
          this.getEmployeeCardPerformer(3);
        } else {
          this.getStoreCardDailyPerformer(3);
        }
      } else {
        if (flag == 2) {
          const selectedWeek = this.weekData[selectedIndex];
          this.cycleId = selectedWeek.id;
          if (this.isEmpCard) {
            this.getEmployeeCardPerformer(2);
          } else {
            this.getStoreCardDailyPerformer(2);
          }
        }
      }
    }
  }

  getTopPerformerData() {
    if (!this.reportHasRun) return;
    if (this.isTableData) {
      if (this.topPerformerTabId === 0) {
        this.getEmployeePerformer();
      }
    } else {
      if (this.isEmpCard) {
        this.getEmpDeptWiseCardDetails();
      } else {
        this.getDeptCardDetails();
      }
    }
  }

  getEmployeePerformer() {
    const now = Date.now();
    if (now - this.lastUpdateTime < this.UPDATE_THRESHOLD) return;
    this.lastUpdateTime = now;
    this.isLoading = true;

    const startDate = this.formatDate(this.startDate);
    const endDate = this.formatDate(this.endDate);
    const prevStart = this.formatDate(this.previousStartDate);
    const prevEnd = this.formatDate(this.previousEndDate);

    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        startDate!,
        endDate!,
        prevStart!,
        prevEnd!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe({
        next: (res: any) => {
          const current = res.currentPerformer;
          const previous = res.lastPerformer;
          current.forEach((p: any, i: number) => {
            p.rank = i + 1;
            p.previousRank =
              previous.findIndex((obj: any) => obj.userId === p.userId) + 1;
            p.position = p.previousRank - p.rank;
          });
          this.performerData = current;
        },
        complete: () => (this.isLoading = false)
      });
  }

  getEmployeeCardPerformer(value: number) {
    if (!this.deptID) this.deptID = 0;
    if (value == 1) {
      this.cycleId = 0;
    }
    // if (value === 2) {
    //   this.startDate = null;
    //   this.endDate = null;
    //   this.previousStartDate = undefined;
    //   this.previousEndDate = undefined;
    // }
    if (value === 3) {
      this.cycleId = 0;
    }

    const startDate = this.formatDate(this.startDate);
    const endDate = this.formatDate(this.endDate);
    const prevStart = this.formatDate(this.previousStartDate);
    const prevEnd = this.formatDate(this.previousEndDate);

    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        startDate!,
        endDate!,
        prevStart!,
        prevEnd!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe((res: any) => {
        const current = res.currentPerformer.slice(0, 3);
        if (value === 1) {
          this.performanceEmpDaily = current;
          this.assignCardImages(this.performanceEmpDaily, true);
        } else if (value === 2) {
          this.performanceEmpWeekly = current;
          this.assignCardImages(this.performanceEmpWeekly, true);
        } else if (value === 3) {
          this.performanceEmpMonthly = current;
          this.assignCardImages(this.performanceEmpMonthly, true);
        }
      });
  }

  getEmpDeptWiseCardDetails() {
    let formattedStartDate: string | null;
    let formattedEndDate: string | null;
    let cycleId;
    if (this.deptDataFetchCount == 0) {
      this.cycleId = 0;
      let dayStartDate = this.dayStartDate;
      let dayEndDate = this.dayEndDate;
      if (this.dayStartDate == null || this.dayEndDate == null) {
        const selectedPeriod = this.periodDayArray[0];
        dayStartDate = selectedPeriod!.startDate;
        dayEndDate = selectedPeriod?.endDate;
      }
      formattedStartDate = this.datepipe.transform(
        dayStartDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      formattedEndDate = this.datepipe.transform(
        dayEndDate,
        'yyyy-MM-dd HH:mm:ss'
      );
    }
    if (this.deptDataFetchCount == 1) {
      if (this.cycleId == 0) {
        this.cycleId = this.weekData[0].id;
      }
      cycleId = this.cycleId;
      formattedStartDate = null;
      formattedEndDate = null;
    }
    if (this.deptDataFetchCount == 2) {
      const today = moment();
      const currentMonthStart = today
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD');
      const currentMonthEnd = today.clone().endOf('month').format('YYYY-MM-DD');
      this.startDate = currentMonthStart;
      this.endDate = currentMonthEnd;
      formattedStartDate = this.datepipe.transform(
        this.startDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      formattedEndDate = this.datepipe.transform(
        this.endDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      this.cycleId = 0;
    }

    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe(
        (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (this.deptDataFetchCount == 0) {
            this.performanceEmpDaily = [];
            this.performanceEmpDaily = currentPerformer.slice(0, 3);
            this.performanceEmpDaily.forEach(
              (performer: any, index: number) => {
                performer.img = performer.profileFileUrl
                  ? performer.profileFileUrl
                  : 'assets/dashboard/default_performer.png';
                performer.icRank = this.icArray[index];
              }
            );
            this.deptDataFetchCount++;
          } else {
            if (this.deptDataFetchCount == 1) {
              this.performanceEmpWeekly = currentPerformer.slice(0, 3);
              this.performanceEmpWeekly.forEach(
                (performer: any, index: number) => {
                  performer.img = performer.profileFileUrl
                    ? performer.profileFileUrl
                    : 'assets/dashboard/default_performer.png';
                  performer.icRank = this.icArray[index];
                }
              );
              this.deptDataFetchCount++;
            } else {
              if (this.deptDataFetchCount == 2) {
                this.performanceEmpMonthly = currentPerformer.slice(0, 3);
                this.performanceEmpMonthly.forEach(
                  (performer: any, index: number) => {
                    performer.img = performer.profileFileUrl
                      ? performer.profileFileUrl
                      : 'assets/dashboard/default_performer.png';
                    performer.icRank = this.icArray[index];
                  }
                );
                this.deptDataFetchCount++;
              }
            }
          }
          if (this.deptDataFetchCount <= 2) this.getTopPerformerData();
          if (this.deptDataFetchCount > 2) this.deptDataFetchCount = 0;
        },
        (err: any) => {}
      );
  }

  getStoreCardDailyPerformer(value: number) {
    if (!this.deptID) this.deptID = 0;
    // if (value === 2) {
    //   this.startDate = null;
    //   this.endDate = null;
    // }
    if (value === 3) {
      this.cycleId = 0;
      this.isItemEntry = false;
    }

    const startDate = this.formatDate(this.startDate);
    const endDate = this.formatDate(this.endDate);
    const prevStart = this.formatDate(this.previousStartDate);
    const prevEnd = this.formatDate(this.previousEndDate);

    this.masterservice
      .getStoreTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        startDate!,
        endDate!,
        prevStart!,
        prevEnd!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe((res: any) => {
        const current = res.currentPerformer.slice(0, 3);
        if (value === 1) {
          this.performanceCardDaily = current;
          this.assignCardImages(this.performanceCardDaily, false);
        } else if (value === 2) {
          this.performanceCardWeekly = current;
          this.assignCardImages(this.performanceCardWeekly, false);
        } else if (value === 3) {
          this.performanceCardMonthly = current;
          this.assignCardImages(this.performanceCardMonthly, false);
        }
      });
  }

  getDeptCardDetails() {
    let formattedStartDate: string | null;
    let formattedEndDate: string | null;
    let cycleId;
    if (this.deptDataFetchCount == 0) {
      cycleId = 0;
      formattedStartDate = this.datepipe.transform(
        this.dayStartDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      formattedEndDate = this.datepipe.transform(
        this.dayEndDate,
        'yyyy-MM-dd HH:mm:ss'
      );
    }
    if (this.deptDataFetchCount == 1) {
      cycleId = this.cycleId;
      formattedStartDate = null;
      formattedEndDate = null;
    }
    if (this.deptDataFetchCount == 2) {
      formattedStartDate = this.datepipe.transform(
        this.startDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      formattedEndDate = this.datepipe.transform(
        this.endDate,
        'yyyy-MM-dd HH:mm:ss'
      );
      cycleId = 0;
    }
    // Assuming isItemEntry is a variable, and its value might be a boolean or a string

    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getStoreTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe(
        (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (this.deptDataFetchCount == 0) {
            this.performanceCardDaily = [];
            this.performanceCardDaily = currentPerformer.slice(0, 3);
            this.performanceCardDaily.forEach(
              (performer: { img: string; icRank: string }, index: number) => {
                performer.img = this.imgArray[index];
                performer.icRank = this.icArray[index];
              }
            );
            this.deptDataFetchCount++;
          } else {
            if (this.deptDataFetchCount == 1) {
              this.performanceCardWeekly = currentPerformer.slice(0, 3);
              this.performanceCardWeekly.forEach(
                (performer: { img: string; icRank: string }, index: number) => {
                  performer.img = this.imgArray[index];
                  performer.icRank = this.icArray[index];
                }
              );
              this.deptDataFetchCount++;
            } else {
              if (this.deptDataFetchCount == 2) {
                this.performanceCardMonthly = currentPerformer.slice(0, 3);
                this.performanceCardMonthly.forEach(
                  (
                    performer: { img: string; icRank: string },
                    index: number
                  ) => {
                    performer.img = this.imgArray[index];
                    performer.icRank = this.icArray[index];
                  }
                );
                this.deptDataFetchCount++;
              }
            }
          }
          if (this.deptDataFetchCount <= 2) this.getTopPerformerData();
          if (this.deptDataFetchCount > 2) this.deptDataFetchCount = 0;
        },
        (err: any) => {}
      );
  }

  private formatDate(value: any): string | null {
    return this.datepipe.transform(value, 'yyyy-MM-dd HH:mm:ss');
  }
  private assignCardImages(data: any[], isEmp: boolean) {
    const imgArray = isEmp ? this.empImgArray : this.imgArray;
    data.forEach((performer: any, index: number) => {
      performer.img =
        isEmp && performer.profileFileUrl && performer.profileFileUrl !== null
          ? performer.profileFileUrl
          : isEmp
            ? 'assets/dashboard/default_performer.png'
            : imgArray[index];
      performer.icRank = this.icArray[index];
    });
  }
}
